import { jsxs as r, jsx as i } from "@emotion/react/jsx-runtime";
import { FullWidthStack as s } from "./SuggestionLabel.styled.js";
import { Icon as t } from "../../Icon/index.js";
import { Stack as e } from "../../Stack/index.js";
import { Text as n } from "../../Text/index.js";
import { SuggestionVisibility as d } from "../../../types/components/select.js";
import { FontAwesomeIconsPartooUsed as c } from "../../../types/components/icon.js";
const h = ({
  suggestionProps: o,
  searchValue: l
}) => {
  const m = o?.suggestionVisibility === d.ALWAYS_VISIBLE;
  return o ? /* @__PURE__ */ r(s, { direction: "row", justifyContent: "space-between", children: [
    /* @__PURE__ */ r(e, { direction: "row", children: [
      /* @__PURE__ */ i(t, { icon: [c.faPlus] }),
      /* @__PURE__ */ i(n, { variant: "bodyMMedium", children: o.label }),
      !m && /* @__PURE__ */ i(n, { variant: "bodyMBold", children: ` “${l}“` })
    ] }),
    /* @__PURE__ */ i(e, { children: /* @__PURE__ */ i(t, { icon: [c.faArrowTurnDownLeft] }) })
  ] }) : void 0;
};
export {
  h as SuggestionLabel
};
